import React, { useRef, useEffect, useState } from "react";
import Editor from "@arcgis/core/widgets/Editor";
import Expand from "@arcgis/core/widgets/Expand";

const EditorWidget = ({view,activeWidget}) => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (activeWidget === "editorWidget") {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [activeWidget]);


  //const {view} = props;
  const editorWidgetDiv = useRef(null);
  useEffect(() => {
    if (editorWidgetDiv.current) {
      const editorWidget = new Editor({
        container: editorWidgetDiv.current,
        view: view,
      });

      return ()=>{
        editorWidget.destroy()
      }
    }
  }, []);
  let style = { display: "initial" };
  if (visible) {
    style.display = "initial";
  } else {
    style.display = "none";
  }

  return(
    <div ref={editorWidgetDiv}style={style}></div>
  )
}
export default EditorWidget
